<template>
  <span class="site-clock d-none d-md-inline text-danger mr-2">
    {{ clock }}
  </span>
</template>

<script>
export default {
  name: 'site-clock',
  data () {
    return {
      clock: '00:00:00'
    }
  },
  created () {
    this.startClock()
  },
  methods: {
    startClock: function () {
      const self = this
      setInterval(() => {
        self.updateClock()
      }, 1000)
    },
    updateClock: function () {
      let currentTime = new Date()

      let currentHours = currentTime.getHours()
      let currentMinutes = currentTime.getMinutes()
      let currentSeconds = currentTime.getSeconds()

      // Pad the minutes and seconds with leading zeros, if required
      currentMinutes = (currentMinutes < 10 ? '0' : '') + currentMinutes
      currentSeconds = (currentSeconds < 10 ? '0' : '') + currentSeconds

      // Choose either "AM" or "PM" as appropriate
      let timeOfDay = (currentHours < 12) ? 'AM' : 'PM'

      // Convert the hours component to 12-hour format if needed
      currentHours = (currentHours > 12) ? currentHours - 12 : currentHours

      // Convert an hours component of "0" to "12"
      currentHours = (currentHours === 0) ? 12 : currentHours

      // Compose the string for display
      let currentTimeString = currentHours + ':' + currentMinutes + ':' + currentSeconds + ' ' + timeOfDay

      // Update the time display
      this.clock = currentTimeString
    }
  }
}
</script>
